import React, { useState } from "react";

import { CalendarClockIcon, ChevronDownIcon, FilterIcon } from "lucide-react";
import { useEffect } from "react";
import { useRef } from "react";
import apiClient from "../../utils/apiClient";
import StrategyWiseOrdersTable from "./StrategyWiseOrdersTable";
import StrategyWiseTradesTable from "./StrategyWiseTradesTable";
import server from "../../utils/serverConfig";

export default function ShowStrategyData({ userId, allUser, ...props }) {
  const [currentTab, setCurrentTab] = useState("orders");

  const [filterDropDown, setFilterDropDown] = useState(false);
  const [filterByDays, setFilterByDays] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [liveTrade, setLiveTrade] = useState([]);

  const filterByDaysRef = useRef(null);
  const filterDropDownRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);

  const liveTradesData = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}live_trades_data`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setLiveTrade(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        filterByDaysRef.current &&
        !filterByDaysRef.current.contains(event.target) &&
        filterByDays
      ) {
        closeFilterByDaysModal();
      }

      if (
        filterDropDownRef.current &&
        !filterDropDownRef.current.contains(event.target) &&
        filterDropDown
      ) {
        closeFilterDroprDownModal();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    liveTradesData(currentPage);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    
  }, [currentPage,filterByDays, filterDropDown]);

  const showFilterDroprDownModal = () => {
    setFilterDropDown(true);
  };

  const showFilterByDaysModal = () => {
    setFilterByDays(true);
  };

  const closeFilterDroprDownModal = () => {
    setFilterDropDown(false);
  };

  const closeFilterByDaysModal = () => {
    setFilterByDays(false);
  };

  const handleRadioChange = (name) => {
    setSelectedRadio(name);
    console.log(`Selected Radio: ${name}`);
  };

  

  const handleChangeTabs = (tabName) => {
    setCurrentTab(tabName);
  };

  const [show, setShow] = useState(false);

  const [state, setState] = useState("FNO");


  const filteredLiveOrder =
    props.liveOrders &&
    props.liveOrders.filter((symbol) => {
      const lastTwoCharacters = symbol.symbol.slice(-2);
      return lastTwoCharacters === "PE" || lastTwoCharacters === "CE";
    });

  const filteredLiveOrderFNO = filteredLiveOrder.reduce(
    (uniqueClientIdArray, currentItem) => {
      const { symbol, strategy, clientId } = currentItem;

      // Check if an object with the same properties already exists in the uniqueClientIdArray
      const existingItemIndex = uniqueClientIdArray.findIndex(
        (item) => item.strategy === strategy
      );

      // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
      if (existingItemIndex === -1) {
        uniqueClientIdArray.push({
          strategy,
          symbols: [symbol],
          clientIds: [clientId],
        });
      } else {
        // If a matching object is found, add the clientId to the matching item's clientIds array
        uniqueClientIdArray[existingItemIndex].clientIds.push(clientId);
        uniqueClientIdArray[existingItemIndex].symbols.push(symbol);
      }

      return uniqueClientIdArray;
    },
    []
  );

  // console.log("New Data ------>", filteredLiveOrderFNO);

 

  const filteredEquityLiveOrder =
    props.liveOrders &&
    props.liveOrders.filter((symbol) => {
      const lastTwoCharacters = symbol.symbol.slice(-2);
      return lastTwoCharacters !== "PE" && lastTwoCharacters !== "CE";
    });

  const filteredLiveOrdersEquity = filteredEquityLiveOrder.reduce(
    (uniqueClientIdArray, currentItem) => {
      const {
        symbol,
        side,
        qty,
        remainingQuantity,
        limitPrice,
        stopPrice,
        status,
        strategy,
        orderDateTime,
        clientId,
      } = currentItem;

      // Check if an object with the same properties already exists in the uniqueClientIdArray
      const existingItemIndex = uniqueClientIdArray.findIndex(
        (item) =>
          item.symbol === symbol &&
          item.side === side &&
          item.qty === qty &&
          item.remainingQuantity === remainingQuantity &&
          item.limitPrice === limitPrice &&
          item.stopPrice === stopPrice &&
          item.status === status &&
          item.strategy === strategy
      );

      // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
      if (existingItemIndex === -1) {
        uniqueClientIdArray.push({
          symbol,
          side,
          qty,
          remainingQuantity,
          limitPrice,
          stopPrice,
          status,
          strategy,
          orderDateTime,
          clientIds: [clientId],
        });
      } else {
        // If a matching object is found, add the clientId to the matching item's clientIds array
        uniqueClientIdArray[existingItemIndex].clientIds.push(clientId);
      }

      return uniqueClientIdArray;
    },
    []
  );

  filteredLiveOrdersEquity.sort((a, b) => {
    const dateA = new Date(a.orderDateTime);
    const dateB = new Date(b.orderDateTime);
    return dateB - dateA;
  });


 //////////////////  Fetch Live Trade ///////////////////////////

 const fnoLiveTrades = liveTrade && liveTrade.filter((symbol) => {
  const lastTwoCharacters = symbol.symbol.slice(-2);
  return lastTwoCharacters === "PE" || lastTwoCharacters === "CE";
});

// console.log("Live Trades fno ----",fnoLiveTrades);

const filteredLiveTradesFNO = fnoLiveTrades.reduce(
  (uniqueClientIdArray, currentItem) => {
    const { symbol,strategy, clientid } =
      currentItem;
    // Check if an object with the same properties already exists in the uniqueClientIdArray
    const existingItemIndex = uniqueClientIdArray.findIndex(
      (item) =>
        item.strategy === strategy 
    );

    // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
    if (existingItemIndex === -1) {
      uniqueClientIdArray.push({
        strategy:strategy,
        symbols: [symbol],
        clientIds: [clientid],
      });
    } else {
      // If a matching object is found, add the clientId to the matching item's clientIds array
      uniqueClientIdArray[existingItemIndex].clientIds.push(clientid);
      uniqueClientIdArray[existingItemIndex].symbols.push(symbol);
    }

    return uniqueClientIdArray;
  },
  []
);

const equityLiveTrades = liveTrade && liveTrade.filter((symbol) => {
  const lastTwoCharacters = symbol.symbol.slice(-2);
  return lastTwoCharacters !== "PE" && lastTwoCharacters !== "CE";
});

// console.log("Live Trades equity ----",equityLiveTrades)

const filteredLiveTradesEquity = equityLiveTrades.reduce(
  (uniqueClientIdArray, currentItem) => {
    const { symbol, side, tradedQty, tradePrice, orderDateTime, clientid } =
      currentItem;

    // Check if an object with the same properties already exists in the uniqueClientIdArray
    const existingItemIndex = uniqueClientIdArray.findIndex(
      (item) =>
        item.symbol === symbol &&
        item.side === side &&
        item.tradedQty === tradedQty &&
        item.tradePrice === tradePrice
    );

    // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
    if (existingItemIndex === -1) {
      uniqueClientIdArray.push({
        symbol,
        side,
        tradedQty,
        tradePrice,
        orderDateTime,
        clientIds: [clientid],
      });
    } else {
      // If a matching object is found, add the clientId to the matching item's clientIds array
      uniqueClientIdArray[existingItemIndex].clientIds.push(clientid);
    }

    return uniqueClientIdArray;
  },
  []
);

// console.log("User trade history ------>", liveTrade);
// console.log("New Data trade history ------>", filteredTradeHistoryFNO);


  

  return (
    <div className="z-0 relative w-full h-full items-end  overflow-hidden bg-black">
      <div className=" flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
        <div className="flex space-x-6">
          <div
            onClick={() => handleChangeTabs("orders")}
            className={` ${
              currentTab === "orders"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px]  text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in    `}
          >
            Orders
          </div>
          <div
            onClick={() => handleChangeTabs("trades")}
            className={` ${
              currentTab === "trades"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Trades
          </div>
        </div>

        <div className="relative flex space-x-4 items-center ">
          <button
            onClick={() => setShow(true)}
            className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
          >
            <span className="text-white text-base">{state}</span>
            <ChevronDownIcon className="h-5 w-5 text-white" />
          </button>

          {show === true && (
            <div className="z-10 absolute top-16 -left-3 bg-gray-800 w-[160px]  p-1 rounded-sm">
              <div className="flex  flex-col space-y-1 h-full p-2">
                <div
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                  onClick={() => {
                    setState("FNO");
                    setShow(false);
                    setCurrentPage(1);
                  }}
                >
                  FNO
                </div>
                <div
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                  onClick={() => {
                    setState("EQUITY");
                    setShow(false);
                  }}
                >
                  EQUITY
                </div>
              </div>
            </div>
          )}

          {/* <button
            ref={filterDropDownRef}
            onClick={showFilterDroprDownModal}
            className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
          >
            <FilterIcon className="h-5 w-5 text-white" />
            <span className="text-white text-base">Filter</span>
          </button> */}

          {/* {filterDropDown && (
            <div
              ref={filterDropDownRef}
              className="absolute top-16 right-0 bg-gray-800 w-[160px]  p-1 rounded-sm"
            >
              <div className="flex  flex-col space-y-4 n h-full p-2">
                <div className="text-white text-base cursor-pointer">
                  By Time
                </div>
                <div className="text-white text-base cursor-pointer">
                  Buy Orders
                </div>
                <div className="text-white text-base cursor-pointer">
                  Sell Orders
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>

      {/* {livePositionsData ? (
        <pre>{JSON.stringify(livePositionData, null, 2)}</pre>
      ) : (
        <p>Waiting for data...</p>
      )}
      {openOrdersData ? (
        <pre>{JSON.stringify(openOrdersData, null, 2)}</pre>
      ) : (
        <p>Waiting for data...</p>
      )} */}

      {currentTab === "trades" && (
        <StrategyWiseTradesTable
         forexTradesHistoryData={
            state === "EQUITY" ? filteredLiveTradesEquity : filteredLiveTradesFNO
          }
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}

      {currentTab === "orders" && (
        <StrategyWiseOrdersTable
          openOrdersData={
            state === "EQUITY" ? filteredLiveOrdersEquity : filteredLiveOrderFNO
          }
          accountName={props.accountName}
          allUser={allUser && allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
}
